export default {
  header: 'Please provide some details',
  placeholder: 'Add a comment...',
};
